import { render } from "./electronicMedicalRecords.vue?vue&type=template&id=c8c09d64"
import script from "./electronicMedicalRecords.vue?vue&type=script&lang=js"
export * from "./electronicMedicalRecords.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__